import * as React from "react"
import {useRoutes} from "react-router-dom";
import AppTheme from "./Theme";

import routes from "./Routes";

import 'rsuite/dist/rsuite-no-reset.min.css';
import 'react-multi-carousel/lib/styles.css';


export default function App() {
    const elements = useRoutes(routes)

    return <AppTheme>
        {elements}
    </AppTheme>
}